/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DashboardNegativeSummary_viewer = {
    readonly report: {
        readonly reportNegativeTradingSummary: ReadonlyArray<{
            readonly notTradedInLastDay: number;
            readonly notTradeInLast7Days: number;
            readonly notTradeInLast4Weeks: number;
            readonly notTradedSinceInception: number;
            readonly tradingWorseThanLastMonth: number;
            readonly tradingBalanceLess100: number;
            readonly totalSpokes: number;
        }> | null;
    } | null;
    readonly " $refType": "DashboardNegativeSummary_viewer";
};
export type DashboardNegativeSummary_viewer$data = DashboardNegativeSummary_viewer;
export type DashboardNegativeSummary_viewer$key = {
    readonly " $data"?: DashboardNegativeSummary_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"DashboardNegativeSummary_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "entityReference"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashboardNegativeSummary_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Report",
      "kind": "LinkedField",
      "name": "report",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "entityReference",
              "variableName": "entityReference"
            }
          ],
          "concreteType": "ReportNegativeTradingSummary",
          "kind": "LinkedField",
          "name": "reportNegativeTradingSummary",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "notTradedInLastDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "notTradeInLast7Days",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "notTradeInLast4Weeks",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "notTradedSinceInception",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tradingWorseThanLastMonth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tradingBalanceLess100",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalSpokes",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'cd0f9fb50b614188c4bb6f9be79b04aa';
export default node;
